module.exports = __webpack_public_path__ + "img/gachita_3_2.b1d5cf2f.png";